module.exports = __webpack_public_path__ + "img/Atri Xpress.d4454cc7.png";